import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { V2Notifikation, V2NotifikationType } from '../../store/models';

@Injectable({
    providedIn: 'root'
})
export class V2NotifikationModalService {

    constructor(
        private http: HttpClient
    ) { }

    getV2Notifikationer(type: V2NotifikationType) {
        const url = `[api]/V2Notifikation/[userId]/${type}`;
        return this.http.get<V2Notifikation[]>(url);
    }

    deleteV2Notifikation(id: number) {
        const url = `[api]/V2Notifikation/${id}`;
        return this.http.delete(url);
    }
}
